// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 24px;
  width: 100%;
  height: 100%;
}

.faixa {
  position:relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 320px;
  height: 40px;
  margin: 24px 0 16px 0px; 

}

.faixa-img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1; 
}

.faixa-texto {
  position: relative;
  z-index: 2; 
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: var(--cor-branco);
  margin-left: 16px; 
}


.card {
  background: var(--cor-roxoClaro);
  border-radius: 16px;
  max-width: 300px;
  max-height: 252px;
  padding: 16px;
  text-align: center;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.card-img {
  width: 120px;
  height: 75px;
  object-fit: contain;
  margin-bottom: 10px;
}

.card-title {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: var(--cor-pretoTitulo);
  margin: 4px 0 2px 0;
}

.autor {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--cor-cinzaCard);
  margin: 0 0 8px 0;
}

.genero,
.ano-publicacao {
  background: var(--cor-roxoClaro);
  border-radius: 4.46px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  padding: 4px 10px;
  margin: 2px 0;
  display: inline-block;
}

.card-link {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: var(--cor-roxoEscuro);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: auto;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease, -webkit-text-decoration 0.2s ease;
  transition: color 0.2s ease, text-decoration 0.2s ease;
  transition: color 0.2s ease, text-decoration 0.2s ease, -webkit-text-decoration 0.2s ease;
}

.card-link:hover {
  color: var(--cor-roxoApoio);
  text-decoration: underline;
}

.card-link img {
  width: 14px;
  height: 14px;
}

.mensagem-sem-top5 {
  text-align: center;
  font-size: 1rem;
  color: var(--cor-cinzaCard);
  margin-top: 20px;
  font-style: italic;
}

.scroll {
   overflow: auto !important;
}


.conteiner-livro h1 {
    font-weight: bold;
    color: var(--cor-pretoForte);
    font-family: "Roboto";
    font-size: 22px;
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/paginas/aluno/TelaInicial.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;;AAGA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,8DAAsD;EAAtD,sDAAsD;EAAtD,yFAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;GACG,yBAAyB;AAC5B;;;AAGA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 24px;\n  width: 100%;\n  height: 100%;\n}\n\n.faixa {\n  position:relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 320px;\n  height: 40px;\n  margin: 24px 0 16px 0px; \n\n}\n\n.faixa-img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1; \n}\n\n.faixa-texto {\n  position: relative;\n  z-index: 2; \n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--cor-branco);\n  margin-left: 16px; \n}\n\n\n.card {\n  background: var(--cor-roxoClaro);\n  border-radius: 16px;\n  max-width: 300px;\n  max-height: 252px;\n  padding: 16px;\n  text-align: center;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n}\n\n.card-img {\n  width: 120px;\n  height: 75px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.card-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--cor-pretoTitulo);\n  margin: 4px 0 2px 0;\n}\n\n.autor {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: var(--cor-cinzaCard);\n  margin: 0 0 8px 0;\n}\n\n.genero,\n.ano-publicacao {\n  background: var(--cor-roxoClaro);\n  border-radius: 4.46px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  padding: 4px 10px;\n  margin: 2px 0;\n  display: inline-block;\n}\n\n.card-link {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: var(--cor-roxoEscuro);\n  text-decoration: none;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: auto;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.2s ease, text-decoration 0.2s ease;\n}\n\n.card-link:hover {\n  color: var(--cor-roxoApoio);\n  text-decoration: underline;\n}\n\n.card-link img {\n  width: 14px;\n  height: 14px;\n}\n\n.mensagem-sem-top5 {\n  text-align: center;\n  font-size: 1rem;\n  color: var(--cor-cinzaCard);\n  margin-top: 20px;\n  font-style: italic;\n}\n\n.scroll {\n   overflow: auto !important;\n}\n\n\n.conteiner-livro h1 {\n    font-weight: bold;\n    color: var(--cor-pretoForte);\n    font-family: \"Roboto\";\n    font-size: 22px;\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
